<template>
<div>
  <el-row type="flex" justify="space-between" class="title-bar">
    <div>
      <div class="title-h3 mr-r10">라우팅 정보</div>
      <span class="mr-r15">최근 수집시간 : <em>{{routeReloadTime}}</em></span>
    </div>
    <div class="vertical-center-box">
      <el-tooltip v-show="isCli" class="item" effect="dark" :content="ROUTING_CLI_RECOMMEND_MESSAGE" placement="bottom">
        <i class="fas fa-info-circle mr-r10 c-pointer" />
      </el-tooltip>
      <el-radio-group class="mr-r10" v-model="tmpDataType" @change="onDataTypeChange">
        <el-radio :label="dataTypeData.snmp.value">{{dataTypeData.snmp.label}}</el-radio>
        <el-radio :label="dataTypeData.cli.value">{{dataTypeData.cli.label}}</el-radio>
      </el-radio-group>
      <el-button class="mr-r4" size="small" type="primary" @click="reloadData">라우팅 정보 갱신</el-button>
      <w-excecute-cli-script-button class="mr-r4" size="small" v-show="dataType === dataTypeData.cli.value" ref="cliScriptButton" :obj="nodeParams" :active="active && dataType === dataTypeData.cli.value" @start-execute-script="cliLoading=true" @end-execute-script="completeExecuteScript" />
      <el-button class="mr-r4" size="small" @click="exportRouteInfo"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px"> 엑셀출력</el-button>
      <w-header-search-button @click="onShowSearchToolButtonClick"></w-header-search-button>
    </div>
  </el-row>
  <el-table-wrapper v-show="dataType === dataTypeData.snmp.value" v-loading="snmpLoading" border :data="tableData" :columns="columns" :show-custom-header="true" :show-search-tool="showSearchTool" ref="table" style="width:100%;" :show-overflow-tooltip="true"
    :pagination="true" :column-default="columnDefault">
  </el-table-wrapper>
  <el-input v-show="dataType === dataTypeData.cli.value" v-loading="cliLoading" type="textarea" v-model="scriptResult" :autosize="{ minRows: 10 }" placeholder="스크립트를 수행해주세요."></el-input>
</div>
</template>

<script>
import isNil from 'lodash/isNil';
import msgUtil from '@/utils/message';
import { EMPTY_TEXT } from '@/utils/string';
import { getDateToString } from '@/utils/date';
import netdeviceInfoAPI from '@/api/config/netdevice/netdevice-info';
import netdeviceRoutingViewMixin from '@/mixins/config/netdevice-routing-view';

export default {
  name: 'WRoutingInfoNode',
  mixins: [netdeviceRoutingViewMixin],
  props: {
    activeTab: {
      type: String,
    },
    nodeParams: {
      type: Object,
    },
  },
  data() {
    return {
      showSearchTool: false,
      dataList: null,
      routeReloadTime: '-',
    };
  },
  computed: {
    objId() {
      return !isNil(this.nodeParams) && !isNil(this.nodeParams.objId) ? this.nodeParams.objId : null;
    },
    active() {
      return !isNil(this.objId) && this.activeTab === this.$options.name;
    },
  },
  watch: {
    activeTab: {
      handler() {
        this.loadData();
      },
    },
    nodeParams: {
      handler() {
        this.dataType = null;
        this.clear();
        this.loadData();
      },
      immediate: true,
    },
    dataType: {
      handler() {
        this.loadData();
      },
    },
  },
  methods: {
    /**
     * 데이터를 초기화한다.
     * @author Ju
     * @return {[type]} [description]
     */
    clear() {
      this.cliLoading = false;
      this.scriptResult = '';
      this.routeReloadTime = EMPTY_TEXT;
      this.tableData = [];
    },
    /**
     * 라우팅 데이터를 조회한다. (mixin override)
     * @author Ju
     * @return {[type]} [description]
     */
    loadData() {
      if (this.active) {
        if (isNil(this.dataType)) {
          this.getRoutingSnapshotTypeOfObj(this.objId);
        } else if (this.dataType === this.dataTypeData.snmp.value) {
          this.loadDataBySnmp();
        }
      }
    },
    /**
     * 데이터를 갱신한다.
     * @author Ju
     * @return {[type]} [description]
     */
    reloadData() {
      if (isNil(this.dataType)) {
        this.getRoutingSnapshotTypeOfObj(this.selectedNode.obj.objId);
      } else if (this.dataType === this.dataTypeData.snmp.value) {
        this.loadDataBySnmp();
      } else {
        this.loadDataByCli();
      }
    },
    /**
     * SNMP로 라우팅 정보를 조회한다. (mixins override)
     * @author Ju
     * @return {[type]} [description]
     */
    loadDataBySnmp() {
      this.snmpLoading = true;
      netdeviceInfoAPI
        .getTcpRoutingInformationList({
          objId: this.objId,
        })
        .then((response) => {
          if (response.data.success) {
            this.tableData = response.data.data;
            this.routeReloadTime = getDateToString(new Date().getTime());
          } else {
            this.failToLoad();
          }
        })
        .catch(() => {
          this.failToLoad();
        })
        .finally(() => {
          this.snmpLoading = false;
        });
    },
    /**
     * 데이터 로드 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoad() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '라우팅 정보', false));
      this.routeReloadTime = EMPTY_TEXT;
    },
    /**
     * 스크립트 수행 완료 이벤트 핸들러
     * @author Ju
     * @param  {[type]} success [description]
     * @param  {[type]} data    [description]
     * @param  {[type]} message [description]
     * @return {[type]}         [description]
     */
    completeExecuteScript(success, data, message) {
      this.cliLoading = false;
      if (success === true) {
        this.routeReloadTime = getDateToString(new Date().getTime());
        this.scriptResult = data;
        if (!isNil(message)) {
          this.$message(message);
        }
        if (!isNil(message)) {
          this.$message(message);
        }
      } else if (success === false) {
        this.$message(msgUtil.getCustomResultMsgData(message, false));
      }
    },
    /**
     * 라우팅 정보를 엑셀로 출력한다.
     * @author Ju
     * @return {[type]} [description]
     */
    exportRouteInfo() {
      if (!isNil(this.objId)) {
        if (this.dataType === this.dataTypeData.snmp.value) {
          netdeviceInfoAPI.exportTcpRoutingInfoList({ objId: this.objId });
        } else {
          this.$refs.cliScriptButton.exportScriptResult();
        }
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/config/node/netdevice/routing/index.vue